export let passValue = <Type>(value: Type) => value;
